import React from 'react'
import { useTranslation } from 'react-i18next'
import { useMe } from '../../../hooks/useMe'
import FactGrid from '../FactGrid'

export default function ParcelFacts({ parcel }) {
  const { t } = useTranslation('parcels')
  const { carrier } = useMe()

  const lastStatus = parcel.statuses?.at(-1)
  const deviationCode =
    parcel.currentStatus === 'deviation' ? lastStatus?.data?.code : null

  const facts = [
    parcel.currentStatus && {
      key: 'status',
      label: t('status'),
      value: `${t(`statuses.${parcel.currentStatus}`)}${
        lastStatus?.data?.extra ? ` (${lastStatus.data.extra.ActionCode})` : ''
      }`,
    },
    deviationCode && {
      key: 'deviationCode',
      label: t('deviationCode'),
      value: t(`deviationCodes.${deviationCode}`, {
        defaultValue: deviationCode,
      }),
    },
    parcel.ageControl && {
      key: 'ageControl',
      label: t('ageControl'),
      value: parcel.ageControl,
    },
    // iBoxen sees which carrier handled the parcel; the carriers know their own
    carrier.isIboxen &&
      parcel.carrierInfo?.name && {
        key: 'carrier',
        label: t('carrier'),
        value: parcel.carrierInfo.name,
      },
    parcel.created && {
      key: 'created',
      label: t('created'),
      value: window.niceDate(parcel.created),
    },
    parcel.flow && {
      key: 'flow',
      label: t('type'),
      value: t(`flows.${parcel.flow}`, { defaultValue: parcel.flow }),
    },
  ].filter(Boolean)
  if (facts.length === 0) return null

  return <FactGrid facts={facts} />
}
